import Icon from "components/atoms/Icon";
import Text from "components/atoms/Text";
import Modal from "components/organisms/Modal";
import ModalBody from "components/organisms/Modal/Body";
import React from "react";
import "./index.scss";

export type ModalView3DProps = {
  isOpen: boolean;
  iframe?: string;
  onCloseRequest?: () => void;
  noPadding?: boolean;
}

const ModalView3D: React.FC<ModalView3DProps> = ({
  isOpen,
  iframe,
  onCloseRequest,
  noPadding
}) => {
  return (
    <div className="o-modalView3D">
      <Modal
        isOpen={isOpen}
        onCloseRequest={onCloseRequest}
        noPadding={noPadding}
      >
        <div className="o-modal_content_icon" onClick={onCloseRequest}>
          <Icon
            iconName="x"
            size="close-smaller"
          />
        </div>
        <ModalBody>
          <div className="o-modalView3D_wrapper">
            <div className="o-modalView3D_wrapper_content">
              <Text
                modifiers={["center"]}
                content={iframe}
              />
            </div>
          </div>
        </ModalBody>
      </Modal>
    </div>
  );
};

export default ModalView3D;
